import UploadInstructionViewModel from './UploadInstructionViewModel';

export default class SubUploadBulkDataViewModel {
  public static createEmpty(): SubUploadBulkDataViewModel {
    return new SubUploadBulkDataViewModel();
  }
  constructor(
    public Description: string = '',
    public ButtonText: string = '',
    public Instructions: UploadInstructionViewModel[] = [],
  ) {}
}

